import React, { Suspense, useEffect } from "react";
import ErrorBoundary from "./components/atoms/error-boundary/ErrorBoundary";
import { useAuthContext } from "./lib/context/AuthContextContext/AuthContext";
import AuthenticatedRoutes from "./routes/AuthenticatedRoutes/AuthenticatedRoutes";
import UnAuthenticatedRoutes from "./routes/UnauthenticatedRoutes/UnauthenticatedRoutes";
import LoadingScreen from "components/atoms/loading-screen/LoadingScreen";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// i18n.js
import HttpApi from 'i18next-http-backend'; // Add this line to load files

i18n
  .use(HttpApi)  // Use Backend plugin to load translations
  .use(initReactI18next)
  .init({
    lng: 'de',
    supportedLngs: ['en', 'de'], // Add the languages you want to support
    fallbackLng: 'de',  // Fallback language if the detected language is not available
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
    backend: {
      loadPath: 'locales/{{lng}}.json'  // Path to your translation files
    }
  });

function App() {

  const { isAuthenticated, isLoading } = useAuthContext();


useEffect(() => {
    const domain = window.location.origin;

    if (domain === "https://berner.insuhub.ch") {
      document.title = `Berner`;
      
      const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (favicon) {
        favicon.href = "/bvlogo.svg"; // Or full URL
      }
    }else if(domain === "https://wefox.insuhub.ch"){
      document.title = `Wefox`;
      
      const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (favicon) {
        favicon.href = "/wefoxfav.png"; // Or full URL
      }
    }

  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <ErrorBoundary >
      <Suspense fallback={<LoadingScreen />}>
        {isAuthenticated ? <AuthenticatedRoutes /> : <UnAuthenticatedRoutes />}
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
